/* app/onboarding/module1/module1Steps.jsx — сценарий Модуля 1 демо-CJM:
   квест-настройка ПОВЕРХ реального интерфейса (замена модального мастера).
   Декларативный список шагов; движок (навигация, PATCH флоу, спотлайт) —
   Module1Overlay. Источник правды прогресса — серверный OnboardingFlow
   (current_step: space→team→pos→data→done, контракт C3); внутренние шаги
   мапятся на слаги через firstStepForSlug (resume после reload/relogin).

   Виды шага:
   - kind:'panel'     — центрированная карточка (welcome / finale);
   - kind:'spotlight' — подсветка реального элемента (target) + подсказка.

   advance — объект или МАССИВ условий (любое сработавшее ведёт дальше):
   - {type:'button', label, nav?}  — кнопка в подсказке (nav — сначала перейти);
   - {type:'event',  name}         — window CustomEvent (onb:ws-created / onb:invited /
                                     onb:integration-active — контракт W3-F2);
   - {type:'appear', selector}     — селектор появился в DOM;
   - {type:'goto',   match, gone?} — URL (pathname+search) содержит match.
   Поля условия: to — id следующего шага (иначе следующий по списку);
   patch — PATCH флоу при срабатывании; ws:true — спец-обработчик создания
   пространства (привязка workspace_id + switchWorkspace); complete:true —
   финал (PATCH {complete:true} + закрытие).

   Прочее у шага: ensure {match,url} — при входе на шаг перейти на нужную
   страницу, если URL не содержит match (один раз, не преследуем пользователя);
   fallbackNav — кнопка прямого перехода в деградации (target не найден);
   skip {patch, to} — необязательный шаг («Пропустить» на карточке).

   Тарифные разделы (lib/planSections.js): у шага может быть section:'integrations' —
   если тариф пространства закрыл раздел, шаг пропускается целиком (resolveM1Step), а во
   флоу честно пишется skipped. copyWithout:{<раздел>:{…}} подменяет поля шага (текст,
   primary, подпись кнопки), когда раздел закрыт; при закрытии нескольких побеждает
   вариант, стоящий в объекте ПОСЛЕДНИМ. */

import { isSectionEnabled } from '../../../lib/planSections.js';

// Линейка слагов — зеркало серверной OnboardingFlowView.STEPS (не менять порознь).
export const M1_SLUGS = ['space', 'team', 'pos', 'data', 'done'];

export const M1_STEPS = [
  // ── space: создать пространство заведения ──────────────────────────────
  {
    id: 'welcome', slug: 'space', kind: 'panel', panel: 'welcome',
    title: 'Настроим ваш ресторан',
    body: 'Пройдём настройку прямо в реальном интерфейсе: создадим пространство заведения, пригласим команду и подключим кассу — всё по шагам.',
    copyWithout: {
      integrations: { body: 'Пройдём настройку прямо в реальном интерфейсе: создадим пространство заведения и пригласим команду — всё по шагам.' },
    },
  },
  {
    id: 'space-create', slug: 'space', kind: 'spotlight',
    // «По системе» (приёмка W3-2): подводим на страницу, но окно мастера
    // открывает САМ пользователь реальной кнопкой — никаких nav на ?create=1.
    target: '[data-onb="biz-create"]', pad: 8, placement: 'auto', clickThrough: true,
    ensure: { match: 'tab=business', url: '/settings?tab=business' },
    title: 'Создайте пространство заведения',
    body: 'Бизнес-пространство — общий дом ресторана: техкарты, аналитика и команда. Нажмите кнопку — откроется мастер создания.',
    copyWithout: {
      analytics: { body: 'Бизнес-пространство — общий дом ресторана: техкарты и команда. Нажмите кнопку — откроется мастер создания.' },
    },
    hint: 'Нажмите «Создать бизнес-пространство»',
    advance: { type: 'appear', selector: '.modal.wizard', to: 'space-fast-start' },
  },
  {
    id: 'space-fast-start', slug: 'space', kind: 'spotlight',
    // Дырка на ВСЮ модалку: поле названия и кнопка должны быть доступны
    // (раньше подсвечивалась только карточка тарифа — ввод перекрывался).
    target: '.modal.wizard', pad: 6, placement: 'auto', clickThrough: true,
    ensure: { match: 'tab=business', url: '/settings?tab=business' },
    title: 'Быстрый старт — уже выбран',
    body: '7 дней бесплатно и без карты. Укажите название заведения и нажмите «Начать бесплатно» — пространство создастся и сразу активируется.',
    hint: 'Введите название → «Начать бесплатно»',
    // мастер закрыли, не создав пространство → ведём обратно к реальной кнопке
    fallbackTarget: '[data-onb="biz-create"]',
    fallbackHint: 'Нажмите «Создать бизнес-пространство»',
    advance: { type: 'event', name: 'onb:ws-created', ws: true, to: 'team-tab' },
  },

  // ── team: пригласить коллег (необязательный) ───────────────────────────
  {
    id: 'team-tab', slug: 'team', kind: 'spotlight',
    target: '[data-onb="biz-sub-team"]', pad: 6, placement: 'auto', clickThrough: true,
    ensure: { match: 'tab=business', url: '/settings?tab=business' },
    title: 'Пригласите команду',
    body: 'Работа в Ресториуме командная: техкарты, аналитика и чаты — общие. Откройте вкладку «Команда».',
    copyWithout: {
      analytics: { body: 'Работа в Ресториуме командная: техкарты и чаты — общие. Откройте вкладку «Команда».' },
    },
    hint: 'Нажмите «Команда»',
    fallbackNav: '/settings?tab=business&sub=team', fallbackLabel: 'Открыть «Команду»',
    // Реальный клик по суб-вкладке пишет &biz=, deep-link приходит как &sub=
    // (одноразовый, конвертится в biz) — принимаем обе формы (ручной QA W3).
    advance: [
      { type: 'goto', match: 'biz=team' },
      { type: 'goto', match: 'sub=team' },
    ],
    skip: { patch: { add_skipped: 'team', current_step: 'pos' }, to: 'pos-tab' },
  },
  {
    id: 'team-invite', slug: 'team', kind: 'spotlight',
    target: '[data-onb="team-invite"]', pad: 8, placement: 'auto', clickThrough: true,
    ensure: { match: 'biz=team', url: '/settings?tab=business&sub=team' },
    title: 'Пригласите коллег',
    body: 'Отправьте приглашение на почту — или скопируйте ссылку и пришлите в мессенджер. Продолжим, как только приглашение создано.',
    hint: 'Создайте приглашение',
    advance: { type: 'event', name: 'onb:invited', patch: { add_completed: 'team', current_step: 'pos' }, to: 'pos-tab' },
    skip: { patch: { add_skipped: 'team', current_step: 'pos' }, to: 'pos-tab' },
  },

  // ── pos: подключить кассу (необязательный; скип pos пропускает и data) ──
  {
    id: 'pos-tab', section: 'integrations', slug: 'pos', kind: 'spotlight',
    target: '[data-onb="biz-sub-integrations"]', pad: 6, placement: 'auto', clickThrough: true,
    ensure: { match: 'tab=business', url: '/settings?tab=business' },
    title: 'Подключите кассу',
    body: 'Ресториум сам подтянет продажи, закупки и цены из iiko или Syrve. Откройте вкладку «Интеграции».',
    hint: 'Нажмите «Интеграции»',
    fallbackNav: '/settings?tab=business&sub=integrations', fallbackLabel: 'Открыть «Интеграции»',
    advance: [
      { type: 'goto', match: 'biz=integrations' },
      { type: 'goto', match: 'sub=integrations' },
    ],
    skip: { patch: { add_skipped: 'pos', current_step: 'done' }, to: 'finale' },
  },
  {
    id: 'pos-guide', section: 'integrations', slug: 'pos', kind: 'spotlight',
    target: '[data-onb="integration-guide"]', pad: 14, placement: 'auto', clickThrough: true,
    ensure: { match: 'biz=integrations', url: '/settings?tab=business&sub=integrations' },
    // Пока провайдер не выбран, гайда в DOM нет — ведём к выбору системы
    // (деградация-в-центре закрывала собой карточки iiko/Syrve, ручной QA W3).
    fallbackTarget: '.provider-pick',
    fallbackHint: 'Выберите iiko или Syrve — появится инструкция',
    title: 'Инструкция — прямо здесь',
    body: 'Пошаговая инструкция подключения: сервисный сотрудник, права и адрес сервера. Как только связь проверена и подключение активно — продолжим автоматически.',
    hint: 'Подключите кассу по инструкции',
    advance: { type: 'event', name: 'onb:integration-active', patch: { add_completed: 'pos', current_step: 'data' }, to: 'data-backfill' },
    skip: { patch: { add_skipped: 'pos', current_step: 'done' }, to: 'finale' },
  },

  // ── data: история подтягивается в фоне ─────────────────────────────────
  {
    id: 'data-backfill', section: 'integrations', slug: 'data', kind: 'spotlight',
    target: '[data-onb="backfill-progress"]', pad: 10, placement: 'auto',
    ensure: { match: 'biz=integrations', url: '/settings?tab=business&sub=integrations' },
    title: 'История подтягивается по месяцам',
    body: 'Загрузка идёт в фоне: свежие месяцы приходят первыми, дальше — глубже в историю. Ждать не нужно, работайте.',
    advance: { type: 'button', label: 'Дальше', patch: { add_completed: 'data', current_step: 'done' }, to: 'finale' },
  },

  // ── done: финал (последний шаг — сам завершает флоу) ───────────────────
  {
    id: 'finale', slug: 'done', kind: 'panel', panel: 'finale',
    title: 'Готово!',
    // Нейтрально к скипам: команда/касса могли быть пропущены (ручной QA W3).
    // Про ассистента — по приёмке: онбординг по нему живёт под «шляпой».
    body: 'Базовая настройка завершена. Пропущенные шаги легко вернуть: Настройки → «Для бизнеса». Ассистент поможет собрать техкарты и разобрать отчёты — а короткое обучение по нему и тур по аналитике всегда под «шляпой» в шапке. Загляните в Аналитику — отчёты собираются по данным вашей кассы.',
    // Кнопка панели завершает флоу и открывает Аналитику (без отдельного
    // шага-принуждения кликнуть по пункту меню — по приёмке).
    primary: { complete: true, nav: '/analytics' },
    copyWithout: {
      // Аналитика открыта, но интеграций нет: отчётов по кассе не будет, а тура по аналитике в
      // «шляпе» нет (он идёт по данным кассы) — зовём на дашборд калькуляций без обещаний.
      integrations: {
        body: 'Базовая настройка завершена. Пропущенные шаги легко вернуть: Настройки → «Для бизнеса». Ассистент поможет собрать техкарты и разобрать отчёты — а короткое обучение по нему всегда под «шляпой» в шапке. Загляните в Аналитику — там сводка по себестоимости вашей продукции.',
      },
      // Аналитики нет: финал не зовёт туда и ведёт к Ассистенту (побеждает вариант выше).
      analytics: {
        body: 'Базовая настройка завершена. Пропущенные шаги легко вернуть: Настройки → «Для бизнеса». Ассистент поможет собрать техкарты и разобрать отчёты — а короткое обучение по нему всегда под «шляпой» в шапке.',
        primary: { complete: true, nav: '/chat' },
        primaryLabel: 'Готово',
      },
    },
  },
];

// Сессионное состояние (module-scope, живёт между маунтами; сброс — перезагрузка).
// dismissed — «Позже»/Esc/крестик: не переоткрываемся до перезагрузки, «шляпа» снимает.
// open — оверлей видим (гейт автозапуска Модуля 2 в ChatShell: не перебивать настройку).
export const m1Session = { dismissed: false, open: false };

// resume: серверный current_step → первый внутренний шаг его секции.
const SLUG_ENTRY = {
  space: 'welcome',
  team: 'team-tab',
  pos: 'pos-tab',
  data: 'data-backfill',
  done: 'finale',
};

export function firstStepForSlug(slug) {
  return SLUG_ENTRY[slug] || 'welcome';
}

export function stepById(id) {
  return M1_STEPS.find((s) => s.id === id) || null;
}

// следующий шаг по списку; для последнего — null
export function nextStepId(id) {
  const i = M1_STEPS.findIndex((s) => s.id === id);
  if (i < 0 || i >= M1_STEPS.length - 1) return null;
  return M1_STEPS[i + 1].id;
}

// позиция слага в линейке (0..4) — для «Шаг N из 5» в карточке
export function slugIndexOf(slug) {
  const i = M1_SLUGS.indexOf(slug);
  return i >= 0 ? i : 0;
}

// Какой шаг показывать на самом деле: шаги закрытого тарифом раздела пропускаются вперёд
// по списку до первого доступного (у нас это финал). skipSlug — слаг ПЕРВОГО пропущенного
// шага: оверлей пишет его во флоу как add_skipped (+ current_step: 'done'), чтобы сервер и
// resume после reload видели честное «касса пропущена», а не вечное «ждём подключения».
// Раздел открыт / sections нет / пространства нет → шаг как есть.
export function resolveM1Step(stepId, workspace) {
  let id = stepId;
  let skipSlug = null;
  for (let guard = 0; id && guard <= M1_STEPS.length; guard += 1) {
    const st = stepById(id);
    if (!st || !st.section || isSectionEnabled(workspace, st.section)) break;
    if (!skipSlug) skipSlug = st.slug;
    id = nextStepId(id);
  }
  return { stepId: id, skipSlug };
}
